import React from 'react';

import BuyInfo from './BuyInfo';
import RegisterResult from './RegisterResult';
import Tasks from './Tasks';
import ActiveList from './ActiveList';
import {
  ProjectOtherActiveRaffle,
  YouWonRaffle,
} from 'api/raffle/raffle_detail';

interface IDrawSectionProps {
  list: ProjectOtherActiveRaffle[];
  screenWidth: number;
  ownList: YouWonRaffle[];
}

const DrawSection: React.FC<IDrawSectionProps> = ({
  list,
  screenWidth,
  ownList,
}) => {
  return (
    <div id="taskPart" className="">
      <div>
        <BuyInfo />

        <RegisterResult />

        <Tasks />

        {screenWidth >= 768 && (
          <ActiveList otherActiveList={list} ownList={ownList} />
        )}
      </div>
    </div>
  );
};

export default DrawSection;
